<template>
  <div class="container-fluid">
    <input v-if="galleryOptions !== null" v-file-uploader="galleryOptions" type="file" name="files" class="gallery_media" />
  </div>
</template>

<style lang="scss" scoped>
</style>

<script src="../../../../assets/libs/fileuploader-2.2/jquery.fileuploader.min.js" type="text/javascript"></script>

<script>
import VueFileUploader from "./../../../../../directives/VueFileUploader.js";
export default {
  name: "VenueImages",
  components: {},
  directives: {
    VueFileUploader
  },
  props: ['venue'],
  data() {
    return {
      galleryOptions: null
    };
  },
  mounted() {
    const files = this.venue.imageUrls.map(imageUrl => (
      {
        name: 'venue.jpg',
        size: 1,
        type: 'image/jpg',
        file: imageUrl,
        data: {
          url: imageUrl
        }
      }
    ));

    this.galleryOptions = {
      deletingImage: false,
      uploadUrl: process.env.VUE_APP_API +'/VenueImages/' + this.venue.id,
      deleteUrl: process.env.VUE_APP_API +'/VenueImages/' + this.venue.id,
      sortUrl: process.env.VUE_APP_API +'/VenueImages/' + this.venue.id,
      files: files
    };
  },
  beforeDestroy: function() {
  },
  methods: {}
};
</script>